import React, { FC } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { PublicPagesInfoWrapper } from './PublicPagesInfoWrapper';
import PublicPageFooter from '../../../app/components/PublicPageFooter';
import { shouldIncludeSmartSchoolButton } from '../../helpers/smartschool';
import { FlexWrapper, StyledContent, StyledLogoContainer, StyledPaper } from './Atoms';
import { LoginButtons } from '../../../security/components/login-buttons';
import { Link } from '@material-ui/core';
import Logo from '../Logo';

type PublicPageWrapperProps = {
  excludeFooter?: boolean;
  backendOnline?: boolean;
  resetPasswordPage?: boolean;
};

export const PublicPageWrapper: FC<PublicPageWrapperProps> = ({
  excludeFooter = false,
  backendOnline = true,
  resetPasswordPage = false,
  children,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.sm));
  const isTablet = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  const showPublicPageInfo = !isTablet && !resetPasswordPage;

  return (
    <FlexWrapper>
      {showPublicPageInfo && (
        <PublicPagesInfoWrapper mobile={isMobile} tablet={isTablet} backendOnline={backendOnline} />
      )}
      <StyledPaper className={resetPasswordPage ? 'full-size reset-password' : ''}>
        <StyledContent className={resetPasswordPage ? 'reset-password' : ''}>
          <StyledLogoContainer>
            <Link href="https://www.lernova.be" target="_blank" rel="noopener noreferrer">
              <Logo id="logo" size="large" variant={'full'} />
            </Link>
          </StyledLogoContainer>
          {children}
        </StyledContent>
        {!resetPasswordPage && shouldIncludeSmartSchoolButton() && backendOnline && (
          <LoginButtons />
        )}
        {!excludeFooter && <PublicPageFooter />}
      </StyledPaper>
    </FlexWrapper>
  );
};
